import React from "react"
import * as styles from "./LandingFooter.module.scss"
import { useSiteQuery } from "../../../hooks"
import { Link } from "gatsby"
import { RichText } from "../../RichText/RichText"
import WhatsAppLink from "../../WhatsApp/WhatsAppLink"

const LandingFooter = () => {
  const { footerLogo, footerCopyrightText, footerFirstPara } = useSiteQuery()

  return (
    <footer
      className="bg-primary-blue c-padding"
      aria-label="Site footer"
      role="contentinfo"
    >
      <div className={styles.whatsappWrapper}>
        <WhatsAppLink
          phoneNumber="919205987106"
          message="Hi, I'm interested in your services."
          loading="lazy"
        />
      </div>
      <div className={`container flex flex-col ${styles.footerContainer}`}>
        <div className={`flex ${styles.footerMenu}`}>
          {/* Col1 */}
          <div className={styles.col1}>
            <img
              src={footerLogo?.file.url}
              alt={footerLogo?.title}
              height={footerLogo?.height}
              width={footerLogo?.width}
              className={styles.footerLogo}
            />
            <p className={styles.paraSection}>
              <RichText content={footerFirstPara} />
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className={`flex justify-between ${styles.copyrightText}`}>
          <p>{footerCopyrightText}</p>
        </div>
      </div>
    </footer>
  )
}
export default LandingFooter
